import MainContainer from "../../layout/MainContainer";
import TableComponent from "../../components/TableComponent";
import { Box, Button, IconButton } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import AddSubCategory from "../../Modals/addSubCategory";

const AddAmenities = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [open, setOpen] = useState(false);

  const handleCloseModal = () => {
    setOpen(false);
  };

  // Dummy data for subcategories
  const rows = [
    { id: 1, name: "Pipe Fitting", date: "02 March 2025" },
    { id: 2, name: "Leak Repair", date: "02 March 2025" },
    { id: 3, name: "Drain Cleaning", date: "02 March 2025" },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const filteredRows = rows.filter((row) =>
    row.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 2,
      minWidth: 220,
      field: "name",
      headerName: "Subcategory Name",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="user_block click_action">
            <figure>
              <img src="/static/images/placeholder.png" alt="" />
            </figure>
            <p>
              <b>{params.row.name}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton onClick={() => {}}>
                <img src="/static/images/edit2_icon.svg" alt="Edit" />
              </IconButton>
            </Box>
            <Box>
              <IconButton onClick={() => {}}>
                <img src="/static/images/trash2_icon.svg" alt="Delete" />
              </IconButton>
            </Box>
            <Box>
              <IconButton onClick={() => {}}>
                <img src="/static/images/eye_icon.svg" alt="View" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  let hidden = ["fullName"];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Subcategories</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          <span onClick={() => navigate("/manage-categories")}>
            {" "}
            Manage Categories
          </span>{" "}
          - Subcategories
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </Box>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpen(true)}>
              <AddIcon /> Add
            </Button>
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            columns={columns.filter((item) => !hidden.includes(item.field))}
            rows={filteredRows}
          />
        </div>
      </div>
      <AddSubCategory open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </MainContainer>
  );
};

export default AddAmenities; 